import "./index.scss";

import React from "react";

const Humburger = ({ isOpen, handleClick }) => {
  return (
    <div
      className={`humburger__wrapper ${isOpen && "humburger__wrapper--active"}`}
      onClick={handleClick}
    >
      <div className={`humburger`}>
        <span className={`humburger__line`} />
        <span className={`humburger__line`} />
        <span className={`humburger__line`} />
      </div>
    </div>
  );
};

export default Humburger;
